var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('BulletinBoard',{attrs:{"isProd":_vm.isProd,"api":_vm.api,"additionalParam":_vm.additionalParam}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }